import axios from './request';
export const UploadFile = (params) => {
  const { file } = params
  const data = new FormData();
  data.append('file', file)
  return axios.post('/upload_file', data)
}
export const publicPath = process.env.NODE_ENV === 'development' ? 'http://49.235.207.167/' : '';
export const actionPath = publicPath + '/index/index/upload_file';
export const exportPerson = (name, id) => {
  return `/index/index/derive?name=${name}&id=${id.join(',')}`//导出人员地址
}

export const exportSpecialist = (name, id) => {
  return `/index/index/derive_specialist?name=${name}&id=${id.join(',')}`
  //导出专家地址
}



// WEBPACK FOOTER //
// ./src/request/public.js